import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { firebaseConnect } from 'react-redux-firebase';
import { AppView, ListSection, Input, Select } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate(['courses', 'terms', 'actions'])
export default class CoursesCourseInformation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      success: false,
      edited: false
    };

    this.formItem = this.formItem.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.edit = this.edit.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.id != nextProps.id) {
      console.log(this.props.id)
      console.log(nextProps.id)
      this.forceUpdate()
    }
  }

  formItem(item, attr, value) {
    let i = {}
    if (this.state[item]) {
      i = this.state[item]
    }
    if (item == 'degree' && attr == 'type') {
      i.title = null
    }
    i[attr] = value
    this.setState({ [item]: i, error: '', edited: true })
  }

  handleEdit() {
    let object = {}
    if (this.state.name && this.state.name.length < 3) {
      this.setState({ error: 'The name has to be at least 3 characters long.'});
      return
    } else {
      object.name = this.state.name || this.props.course.name
    }
    // degree
    if (!this.state.degree && !this.props.course.degree) {
      this.setState({ error: 'You have to set the degree'});
      return
    }
    if (this.state.degree) {
      if (!this.state.degree.type && !this.props.course.degree.type) {
        this.setState({ error: 'Degree Type'});
        return
      } else {
        if (this.state.degree.title == undefined && this.state.degree.title != null) {
          object.degree = {
            type: this.state.degree.type || this.props.course.degree.type
          }
        } else {
          object.degree = {
            type: this.state.degree.type || this.props.course.degree.type,
            title: this.state.degree.title
          }
        }
      }
    }
    // duration
    if (!this.state.duration && !this.props.course.duration) {
      this.setState({ error: 'You have to set the duration'});
      return
    }
    if (this.state.duration) {
      if ((!this.props.course.duration.start && !this.state.duration.start) || (this.state.duration.start && this.state.duration.start.length < 1)) {
        this.setState({ error: 'Duration Start'});
        return
      }
      if (!this.props.course.duration.amount && this.state.duration.amount == undefined) {
        this.setState({ error: 'Duration Amount'});
        return
      }
      if ((!this.props.course.duration.interval && !this.state.duration.interval) || (this.state.duration.interval && this.state.duration.interval.length < 1)) {
        this.setState({ error: 'Duration Interval'});
        return
      }
      if ((!this.props.course.duration.type && !this.state.duration.type) || (this.state.duration.type && this.state.duration.type.length < 1)) {
        this.setState({ error: 'Duration Type'});
        return
      }
      object.duration = Object.assign(this.props.course.duration, this.state.duration)
    }
    // credits
    if (!this.state.credits && !this.props.course.credits) {
      this.setState({ error: 'You have to set the Credits'});
      return
    }
    if (this.state.credits) {
      if (this.state.credits.amount == undefined) {
        this.setState({ error: 'Credits Amount'});
        return
      }
      if (this.state.credits.amount != '0' && !this.state.credits.type) {
        this.setState({ error: 'Credits Type'});
        return
      }
      if (this.state.credits.amount == '0') {
        object.credits = {
          amount: 0,
          type: 'none'
        }
      } else {
        object.credits = {
          amount: this.state.credits.amount,
          type: this.state.credits.type
        }
      }
    }
    // costs
    if (!this.state.costs && !this.props.course.costs) {
      this.setState({ error: 'You have to set the costs'});
      return
    }
    if (this.state.costs) {
      if (this.state.costs.amount == undefined) {
        this.setState({ error: 'Costs Amount'});
        return
      }
      if (this.state.costs.amount != '0' && !this.state.costs.currency) {
        this.setState({ error: 'Costs Currency'});
        return
      }
      if (this.state.costs.amount != '0' && !this.state.costs.interval) {
        this.setState({ error: 'Costs Interval'});
        return
      }
      if (this.state.costs.amount == '0') {
        object.costs = {
          amount: 0,
          currency: 'eur',
          interval: 100
        }
      } else {
        object.costs = {
          amount: this.state.costs.amount,
          currency: this.state.costs.currency,
          interval: this.state.costs.interval
        }
      }
    }
    // requirements
    if (this.state.requirements && Object.keys(this.state.requirements).length !== 0 && this.state.requirements.constructor === Object) {
      let requirements = {}
      if (this.state.requirements.numerus_clausus) {
        requirements.numerus_clausus = this.state.requirements.numerus_clausus
      }
      if (this.state.requirements.degree) {
        requirements.degree = this.state.requirements.degree
      }
      if (this.state.requirements.credits != undefined) {
        requirements.credits = this.state.requirements.credits
      }
      object.requirements = Object.assign(this.props.course.requirements, requirements)
    }
    // additions
    if (this.state.additions && Object.keys(this.state.additions).length !== 0 && this.state.additions.constructor === Object) {
      if (this.state.additions.languages) {
        object.languages = this.state.additions.languages
      }
      // WIP first click does not set both
      if (this.state.additions.online != undefined) {
        object.online = this.state.additions.online
      }
      if (this.state.additions.offline != undefined) {
        object.offline = this.state.additions.offline
      }
      if (this.state.additions.url) {
        object.url = this.state.additions.url
      }
    }

    console.log(object);
    this.edit('courses', this.props.id, object)
  }

  edit(type, id, data) {
    this.props.firebase.update(
      `${type}/${id}`, data
    )
    .then(this.setState({ edited: false, success: true }))
    .then(setTimeout( () => this.setState({ success: false }), 1500))
  }

  render() {
    const { course } = this.props
    let buttons = []
    if (this.state.error) {
      buttons[0] = { key: 1, type: 'alert', text: this.state.error }
    } else if (this.state.success) {
      buttons[0] = { key: 1, type: 'success', text: this.props.t('actions:info.success-updated') }
    } else if (this.state.edited) {
      buttons[0] = { key: 1, type: 'success', text: this.props.t('actions:text.save'), action: this.handleEdit, outline: true }
    } else {
      buttons = []
    }
    return (
      <AppView
        tabcontent
        buttons={ buttons }>
        <ListSection margin padding
          title="Allgemein"
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input
            meta={ this.props.t('terms:course-name') }
            placeholder={ course && course.name }
            onChange={ (e) => this.setState({ name: e.target.value }) } />
        </ListSection>
        <ListSection
          title="Degree"
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Select half
            meta={ this.props.t('terms:degree-type') }
            options={[
              { value: 'bachelor', label: this.props.t('degree:type.bachelor') },
              { value: 'master', label: this.props.t('degree:type.master') },
              { value: 'stateexamination', label: this.props.t('degree:type.stateexamination') },
              { value: 'diploma', label: this.props.t('degree:type.diploma') },
            ]}
            placeholder={ course && course.degree && course.degree.type ? course.degree.type : this.props.t('courses:modals.placeholder.degree-type') }
            onChange={ (e) => this.formItem('degree', 'type', e.value ) }
            />
          <Select half
            required
            meta={ this.props.t('terms:degree-title') }
            options={
              this.state.degree && this.state.degree.type == 'bachelor' ?
              [
                { value: 'ba', label: this.props.t('degree:title.ba') },
                { value: 'bed', label: this.props.t('degree:title.bed') },
                { value: 'beng', label: this.props.t('degree:title.beng') },
                { value: 'bfa', label: this.props.t('degree:title.bfa') },
                { value: 'llb', label: this.props.t('degree:title.llb') },
                { value: 'bmus', label: this.props.t('degree:title.bmus') },
                { value: 'bsc', label: this.props.t('degree:title.bsc') },
              ]
              : this.state.degree && this.state.degree.type == 'master' ?
                [
                  { value: 'ma', label: this.props.t('degree:title.ma') },
                  { value: 'mba', label: this.props.t('degree:title.mba') },
                  { value: 'med', label: this.props.t('degree:title.med') },
                  { value: 'meng', label: this.props.t('degree:title.meng') },
                  { value: 'llm', label: this.props.t('degree:title.llm') },
                  { value: 'mmus', label: this.props.t('degree:title.mmus') },
                  { value: 'msc', label: this.props.t('degree:title.msc') },
                ]
                : []
            }
            placeholder={ course && course.degree && course.degree.title ? course.degree.title : this.props.t('courses:modals.placeholder.degree-title') }
            onChange={ (e) => this.formItem('degree', 'title', e.value ) } />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:duration') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input half
            type="number"
            meta={ this.props.t('terms:duration-amount') }
            placeholder={ course && course.duration && course.duration.amount != undefined ? course.duration.amount : this.props.t('courses:modals.placeholder.duration-amount') }
            onChange={ (e) => this.formItem('duration', 'amount', parseInt(e.target.value)) } />
          <Select half
            meta={ this.props.t('terms:duration-interval') }
            options={[
              { value: 6, label: this.props.t('duration:interval.6') },
              { value: 3, label: this.props.t('duration:interval.3') },
              { value: 12, label: this.props.t('duration:interval.12') },
            ]}
            placeholder={ course && course.duration && course.duration.interval ? course.duration.interval : this.props.t('courses:modals.placeholder.duration-interval') }
            onChange={ (e) => this.formItem('duration', 'interval', e.value) }
            />
          <Select half multi
            meta={ this.props.t('terms:duration-start') }
            options={
              this.state.duration && this.state.duration.interval == '3' ?
              [
                { value: '0', label: this.props.t('duration:start.0') },
                { value: '3', label: this.props.t('duration:start.3') },
                { value: '6', label: this.props.t('duration:start.6') },
                { value: '9', label: this.props.t('duration:start.9') },
              ]
              :
              [
                { value: '4', label: this.props.t('duration:start.4') },
                { value: '10', label: this.props.t('duration:start.10') },
              ]
            }
            placeholder={ course && course.duration && course.duration.start ? course.duration.start : this.props.t('courses:modals.placeholder.duration-start') }
            onChange={ (e) => this.formItem('duration', 'start', e) }
            />
          <Select half
            meta={ this.props.t('terms:duration-type') }
            options={[
              { value: 'full-time', label: this.props.t('duration:type.full-time') },
              { value: 'part-time', label: this.props.t('duration:type.part-time') },
              { value: 'dual', label: this.props.t('duration:type.dual') },
            ]}
            placeholder={ course && course.duration && course.duration.type ? course.duration.type : this.props.t('courses:modals.placeholder.duration-type') }
            onChange={ (e) => this.formItem('duration', 'type', e.value) }
            />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:credits') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input half
            type="number"
            meta={ this.props.t('terms:credits-amount') }
            placeholder={ course && course.credits && course.credits.amount != undefined ? course.credits.amount : this.props.t('courses:modals.placeholder.credits-amount') }
            onChange={ (e) => this.formItem('credits', 'amount', parseInt(e.target.value)) } />
          <Select half
            meta={ this.props.t('terms:credits-type') }
            options={[
              { value: 'ects', label: 'ECTS' },
              { value: 'cats', label: 'CATS' },
              { value: 'gpa', label: 'GPA' },
              { value: 'sch', label: 'SCH' },
            ]}
            placeholder={ course && course.credits && course.credits.type ? course.credits.type : this.props.t('courses:modals.placeholder.credits-type') }
            onChange={ (e) => this.formItem('credits', 'type', e.value) }
            />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:costs') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input half
            type="number"
            meta={ this.props.t('terms:costs-amount') }
            placeholder={ course && course.costs && course.costs.amount != undefined ? course.costs.amount : this.props.t('courses:modals.placeholder.costs-amount') }
            onChange={ (e) => this.formItem('costs', 'amount', parseInt(e.target.value)) } />
          <Select half
            meta={ this.props.t('terms:currency') }
            options={[
              { value: 'usd', label: '$' },
              { value: 'eur', label: '€' }
            ]}
            placeholder={ course && course.costs && course.costs.currency ? course.costs.currency : this.props.t('courses:modals.placeholder.costs-currency') }
            onChange={ (e) => this.formItem('costs', 'currency', e.value) }
            />
          <Select
            meta={ this.props.t('terms:costs-interval') }
            options={[
              { value: 100, label: this.props.t('courses:modals.costs.interval.100') },
              { value: 12, label: this.props.t('courses:modals.costs.interval.12') },
              { value: 6, label: this.props.t('courses:modals.costs.interval.6') },
              { value: 3, label: this.props.t('courses:modals.costs.interval.3') },
              { value: 1, label: this.props.t('courses:modals.costs.interval.1') },
              { value: 101, label: this.props.t('courses:modals.costs.interval.101') }
            ]}
            placeholder={ course && course.costs && course.costs.interval ? course.costs.interval : this.props.t('courses:modals.placeholder.costs-interval') }
            onChange={ (e) => this.formItem('costs', 'interval', e.value) }
            />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:requirements') }
          accent={{ highlight: 'turquoise'}}>
          <Input half
            meta={ this.props.t('terms:numerus_clausus') }
            placeholder={ course && course.requirements && course.requirements.numerus_clausus ? course.requirements.numerus_clausus : this.props.t('courses:modals.placeholder.numerus_clausus') }
            onChange={ (e) => this.formItem('requirements', 'numerus_clausus', e.target.value) } />
          <Select half multi
            meta={ this.props.t('terms:degree') }
            options={[
              { value: 'bachelor', label: this.props.t('degree:type.bachelor') },
              { value: 'master', label: this.props.t('degree:type.master') },
              { value: 'stateexamination', label: this.props.t('degree:type.stateexamination') },
              { value: 'diploma', label: this.props.t('degree:type.diploma') },
              { value: 'abitur', label: this.props.t('degree:type.abitur') },
              { value: 'fachabitur', label: this.props.t('degree:type.fachabitur') },
              { value: 'training', label: this.props.t('degree:type.training') }
            ]}
            placeholder={ course && course.requirements && course.requirements.degree ? course.requirements.degree : this.props.t('courses:modals.placeholder.degree-type') }
            onChange={ (e) => this.formItem('requirements', 'degree', e) }
            />
          <Input half
            type="number"
            meta={ this.props.t('terms:credits') }
            placeholder={ course && course.requirements && course.requirements.credits ? course.requirements.credits : this.props.t('courses:modals.placeholder.credits-amount') }
            onChange={ (e) => this.formItem('requirements', 'credits', e.target.value) } />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:additions') }
          accent={{ highlight: 'turquoise'}}>
          <Select half multi
            meta={ this.props.t('terms:languages') }
            options={[
              { value: 'de', label: this.props.t('languages:de') },
              { value: 'en', label: this.props.t('languages:en') },
              { value: 'nl', label: this.props.t('languages:nl') },
              { value: 'fr', label: this.props.t('languages:fr') },
              { value: 'es', label: this.props.t('languages:es') },
              { value: 'da', label: this.props.t('languages:da') },
            ]}
            placeholder={ course && course.languages ? course.languages : this.props.t('courses:modals.placeholder.languages') }
            onChange={ (e) => this.formItem('additions', 'languages', e) }
            />
          <Select half
            meta={ this.props.t('terms:channel') }
            options={[
              { value: 'online', label: this.props.t('courses:modals.channel.online') },
              { value: 'offline', label: this.props.t('courses:modals.channel.offline') },
              { value: 'both', label: this.props.t('courses:modals.channel.both') }
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.channel') }
            onChange={ (e) => {
              if (e.value == 'both') {
                this.formItem('additions', 'online', true)
                this.formItem('additions', 'offline', true)
              } else if (e.value == 'online') {
                this.formItem('additions', 'online', true)
                this.formItem('additions', 'offline', false)
              } else if (e.value == 'offline') {
                this.formItem('additions', 'online', false)
                this.formItem('additions', 'offline', true)
              }
            }}
            />
          <Input
            meta={ this.props.t('terms:url') }
            placeholder={ course && course.url ? course.url : this.props.t('courses:modals.placeholder.url') }
            onChange={ (e) => this.formItem('additions', 'url', e.target.value) } />
        </ListSection>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/course/information/index.jsx